import React, { useState } from "react";
import { XCircle } from "lucide-react";
import "../css-dashboard/Dashboard.css";
import { Link } from "react-router-dom";
import TravelAgency from "../../assets/travel-agency.svg";
import Reward from "../../assets/reward.svg";
import EmAndamento from "../../assets/em-andamento.svg";
import SidebarTraveler from "../../components/sidebar-dashboard/SidebarTraveler";
import TravelerTripsProgressNegotiations from "../../components/traveler-trips-negotiations/TravelerTripsProgressNegotiations";
import UseTravelerTripsNegotiations from "../../hooks/UseTripsNegotiations/UseTravelerTripsNegotiations";
import UseTripNegotiationPayment from "../../hooks/UsePaymentServiceTripNegotiation/UsePaymentServiceTripNegotiation";
import UseNotAcceptOrderTripNegotiation from "../../hooks/UseNotAcceptOrderTripNegotiation/UseNotAcceptOrderTripNegotiation";
import UseNotAcceptOrderTripAvailable from "../../hooks/UseNotAcceptOrderTripAvailable/UseNotAcceptOrderTripAvailable";
import TravelsAvailable from "../../components/travels-available/TravelsAvailable";
import UseTripsAvailable from "../../hooks/UseTripsAvailable/UseTripsAvailable";
import UseModalReceiverData from "../../hooks/UseModalReceiverData/UseModalReceiverData";
import ModalReceiverData from "../../components/modal-receiver-data/ModalReceiverData";
import UseModalPhotosOrder from "../../hooks/UseModalPhotosOrder/UseModalPhotosOrder";
import ModalPhotosOrder from "../../components/modal-photos-order/ModalPhotosOrder";
import UseModalChat from "../../hooks/UseModalChat/UseModalChat";
import ModalChat from "../../components/modal-chat/ModalChat";

const DashboardTraveler = ({ menuOpen, setMenuOpen }) => {
  const [showRefuseModal, setShowRefuseModal] = useState(false);
  const [showMsgRefuseModal, setShowMsgRefuseModal] = useState("");
  const [serieCancelOrder, setSerieCancelOrder] = useState("");
  const [serieCancelTripsAvailable, setSerieCancelTripsAvailable] =
    useState("");

  const { tripsAvailable, loadingTripsAvailable } = UseTripsAvailable();
  const {
    tripsNegotiations,
    loadingTripsNegotiations,
    refetchTripsNegotiations,
  } = UseTravelerTripsNegotiations();

  const {
    isOpenReceiverData,
    showSuccessScreenReceiverData,
    openModalReceiverData,
    closeModalReceiverData,
    selectedNegotiationReceiverData,
    formDataReceiverData,
    handleChange,
    handlePhoneChange,
    handleBlur,
    handleSubmit,
    loadingReceiverData,
    errorReceiverData,
    successReceiverData,
    errorsReceiverData,
  } = UseModalReceiverData(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenPhotosOrder,
    showSuccessScreenPhotosOrder,
    selectedNegotiationPhotosOrder,
    photosPhotosOrder,
    loadingPhotosOrder,
    errorPhotosOrder,
    successPhotosOrder,
    modePhotosOrder,

    openPhotosOrderModal,
    closePhotosOrderModal,

    handleChangePhotoOrder,
    handleSubmitPhotosOrder,
  } = UseModalPhotosOrder(() => {
    refetchTripsNegotiations();
  });

  const {
    isOpenChat,
    selectedNegotiationChat,
    currentRoleChat,
    messagesChat,
    messageChat,
    emojiList,
    setShowEmojiPickerChat,
    showEmojiPickerChat,
    handleEmojiSelect,
    loadingMessagesChat,
    sendingChat,
    errorChat,
    messagesEndRef,
    openChatModal,
    closeChatModal,
    handleMessageChange,
    handleSendMessage,
  } = UseModalChat(() => {
    refetchTripsNegotiations();
  });

  const { paymentInsurance } = UseTripNegotiationPayment(() => {
    refetchTripsNegotiations();
  });

  const { loadingCancelOrder, cancelOrder } =
    UseNotAcceptOrderTripNegotiation();

  const { loadingCancelOrderTripAvailable, cancelOrderTripAvailable } =
    UseNotAcceptOrderTripAvailable();

  const handleCancelOrder = async (serie) => {
    await cancelOrder(serie, "traveler");
    setShowRefuseModal(false);
  };

  const handleCancelTripsAvailable = async (serie) => {
    alert(serie);
    return;
    await cancelOrderTripAvailable(serie);
    setShowRefuseModal(false);
  };

  return (
    <>
      <div className={`dashboard-container ${menuOpen ? "menu-open" : ""}`}>
        <SidebarTraveler menuOpen={menuOpen} setMenuOpen={setMenuOpen} />

        <main className="main-content">
          <div className="dashboard-header">
            <h1>Dashboard do Viajante</h1>
            <p className="breadcrumb">
              <a href="/dashboard-traveler">Início</a> / Dashboard do Viajante
            </p>
          </div>

          <section className="stats-grid">
            <div className="stat-card">
              <div className="dashboard-icon blue">
                <img src={Reward} alt="" />
              </div>

              <div className="stat-info">
                <span>Total de Ganhos</span>
                <h2 className="total-earns">R$0,00</h2>
              </div>
            </div>

            <div className="stat-card">
              <div className="dashboard-icon teal">
                <img src={TravelAgency} alt="" />
              </div>

              <div className="stat-info">
                <span>Viagens Realizadas</span>
                <h2>
                  {
                    tripsNegotiations.filter((item) =>
                      ["8"].includes(item.trip_status),
                    ).length
                  }
                </h2>
                <Link to="#">
                  <div className="view-details">Ver detalhes</div>
                </Link>
              </div>
            </div>

            <div className="stat-card">
              <div className="dashboard-icon orange">
                <img src={EmAndamento} alt="" />
              </div>

              <div className="stat-info">
                <span>Viagens em andamento</span>
                <h2>
                  {
                    tripsNegotiations.filter((item) =>
                      [
                        "2",
                        "3",
                        "4",
                        "destinatario_recusou",
                        "5",
                        "6",
                        "7",
                      ].includes(item.trip_status),
                    ).length
                  }
                </h2>
                <Link to="#">
                  <div className="view-details">Ver detalhes</div>
                </Link>
              </div>
            </div>
          </section>

          <TravelerTripsProgressNegotiations
            tripsNegotiations={tripsNegotiations}
            loadingTripsNegotiations={loadingTripsNegotiations}
            onOpenReceiverModal={openModalReceiverData}
            onOpenPhotosOrderModal={openPhotosOrderModal}
            onOpenChatModal={openChatModal}
            paymentInsurance={paymentInsurance}
            setSerieCancelOrder={setSerieCancelOrder}
            setShowRefuseModal={setShowRefuseModal}
            setShowMsgRefuseModal={setShowMsgRefuseModal}
          />

          <TravelsAvailable
            tripsAvailable={tripsAvailable}
            loadingTripsAvailable={loadingTripsAvailable}
            setSerieCancelTripsAvailable={setSerieCancelTripsAvailable}
            setShowMsgRefuseModal={setShowMsgRefuseModal}
            setShowRefuseModal={setShowRefuseModal}
          />
        </main>
      </div>

      <ModalReceiverData
        isOpenReceiverData={isOpenReceiverData}
        showSuccessScreenReceiverData={showSuccessScreenReceiverData}
        closeModalReceiverData={closeModalReceiverData}
        formDataReceiverData={formDataReceiverData}
        handleChange={handleChange}
        handlePhoneChange={handlePhoneChange}
        handleBlur={handleBlur}
        handleSubmit={handleSubmit}
        loadingReceiverData={loadingReceiverData}
        errorReceiverData={errorReceiverData}
        errorsReceiverData={errorsReceiverData}
        successReceiverData={successReceiverData}
        selectedNegotiationReceiverData={selectedNegotiationReceiverData}
      />

      <ModalPhotosOrder
        isOpenPhotosOrder={isOpenPhotosOrder}
        closePhotosOrderModal={closePhotosOrderModal}
        showSuccessScreenPhotosOrder={showSuccessScreenPhotosOrder}
        selectedNegotiationPhotosOrder={selectedNegotiationPhotosOrder}
        photosPhotosOrder={photosPhotosOrder}
        loadingPhotosOrder={loadingPhotosOrder}
        errorPhotosOrder={errorPhotosOrder}
        successPhotosOrder={successPhotosOrder}
        modePhotosOrder={modePhotosOrder}
        handlePhotoChange={handleChangePhotoOrder}
        handleSubmit={handleSubmitPhotosOrder}
      />

      <ModalChat
        isOpenChat={isOpenChat}
        selectedNegotiationChat={selectedNegotiationChat}
        currentRoleChat={currentRoleChat}
        messagesChat={messagesChat}
        messageChat={messageChat}
        emojiList={emojiList}
        setShowEmojiPickerChat={setShowEmojiPickerChat}
        showEmojiPickerChat={showEmojiPickerChat}
        handleEmojiSelect={handleEmojiSelect}
        loadingMessagesChat={loadingMessagesChat}
        sendingChat={sendingChat}
        errorChat={errorChat}
        messagesEndRef={messagesEndRef}
        closeChatModal={closeChatModal}
        handleMessageChange={handleMessageChange}
        handleSendMessage={handleSendMessage}
      />

      {showRefuseModal && (
        <div
          className="modal-overlay"
          onClick={() => setShowRefuseModal(false)}
          style={{
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              width: "90%",
              maxWidth: "500px",
              background: "#fff",
              borderRadius: "24px",
              padding: "30px",
              textAlign: "center",
              boxShadow: "0 20px 60px rgba(0,0,0,.15)",
            }}
          >
            <XCircle
              size={70}
              color="#ef4444"
              style={{ marginBottom: "16px" }}
            />

            <h2
              style={{
                marginBottom: "12px",
                color: "#111827",
              }}
            >
              {showMsgRefuseModal === "trip_negotiations" ||
              showMsgRefuseModal === "cancel_travel_available" ? (
                <span>Confirmar cancelamento</span>
              ) : (
                "Aviso"
              )}
            </h2>

            <p
              style={{
                color: "#6b7280",
                lineHeight: 1.6,
                marginBottom: "24px",
              }}
            >
              {showMsgRefuseModal === "trip_negotiations" ? (
                <span>Tem certeza que deseja não levar esta encomenda?</span>
              ) : showMsgRefuseModal === "cancel_travel_available" ? (
                <span>Tem certeza que deseja cancelar essa viagem?</span>
              ) : (
                <span>Não pode editar uma viagem ja em negociacao</span>
              )}
            </p>

            <div
              style={{
                display: "flex",
                gap: "12px",
                justifyContent: "center",
              }}
            >
              <button
                type="button"
                onClick={() => setShowRefuseModal(false)}
                className="action-btn ghost"
                style={{
                  width: "50%",
                  height: "50px",
                }}
              >
                {showMsgRefuseModal === "trip_negotiations" ||
                showMsgRefuseModal === "cancel_travel_available" ? (
                  <span>Voltar</span>
                ) : (
                  "Entendi"
                )}
              </button>

              {(showMsgRefuseModal === "trip_negotiations" ||
                showMsgRefuseModal === "cancel_travel_available") && (
                <button
                  type="button"
                  className="refuse-order-btn"
                  onClick={() => {
                    if (showMsgRefuseModal === "trip_negotiations") {
                      handleCancelOrder(serieCancelOrder);
                    } else if (
                      showMsgRefuseModal === "cancel_travel_available"
                    ) {
                      handleCancelTripsAvailable(serieCancelTripsAvailable);
                    }
                  }}
                  disabled={
                    loadingCancelOrder || loadingCancelOrderTripAvailable
                  }
                  style={{
                    width: "50%",
                    height: "50px",
                  }}
                >
                  {loadingCancelOrder || loadingCancelOrderTripAvailable
                    ? "Cancelando..."
                    : "Sim, cancelar"}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardTraveler;
